import { useRef } from 'react'
import { useTeamSelectGridOptions } from './gridOptions'
import { BulkSheetView } from '../../../../../containers/BulkSheetView'
import {
  useTeamSelectSnapshotData,
  useTeamSelectTemplateData,
} from './hooks/useTeamSelectData'

type TeamSelectProps = {
  snapshotUuid: string
  selectedUuids: string[]
  updateSelectedUuid: (uuid: string, selected: boolean) => void
}

type TeamTemplateSelectProps = {
  projectUuid: string
  selectedUuids: string[]
  updateSelectedUuid: (uuid: string, selected: boolean) => void
}

export const TeamSelectGrid = ({
  snapshotUuid,
  selectedUuids,
  updateSelectedUuid,
}: TeamSelectProps) => {
  const gridOptions = useTeamSelectGridOptions(updateSelectedUuid)
  const ref = useRef<HTMLDivElement>(null)
  const { rows } = useTeamSelectSnapshotData(snapshotUuid, selectedUuids)
  return <BulkSheetView ref={ref} gridOptions={gridOptions} rowData={rows} />
}

export const TeamTemplateSelectGrid = ({
  projectUuid,
  selectedUuids,
  updateSelectedUuid,
}: TeamTemplateSelectProps) => {
  const gridOptions = useTeamSelectGridOptions(updateSelectedUuid)
  const ref = useRef<HTMLDivElement>(null)
  const { rows } = useTeamSelectTemplateData(projectUuid, selectedUuids)
  return <BulkSheetView ref={ref} gridOptions={gridOptions} rowData={rows} />
}
